import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
if (process.env.NODE_ENV !== "development") {
    Sentry.init({
        Vue,
        dsn: "https://e8994345330b4cad9e7851e09197bd91@o920934.ingest.sentry.io/5970091",
        integrations: [
            new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracingOrigins: ["localhost", "app.lessonpro.co.uk", /^\//],
            }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
}

import store from "./store";
import "reset-css";
import Cookie from "js-cookie";
import Notifications from "vue-notification";
//import VueDayjs from 'vue-dayjs-plugin'
import VueCurrencyInput from "vue-currency-input";
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css';
import VueCurrencyFilter from "vue-currency-filter";

import TextareaAutosize from "vue-textarea-autosize";
Vue.use(TextareaAutosize);

import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
Vue.use(CoolLightBox);

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

Vue.component("vue-phone-number-input", VuePhoneNumberInput);

import PhoneNumberField from "./components/Shared/fields/phone-number-field.vue";
Vue.component("phone-number-field", PhoneNumberField);

Vue.prototype.$env = process.env;
for (var i in Vue.prototype.$env) {
    if (process.env[i] == "true") {
        Vue.prototype.$env[i] = true;
    } else if (process.env[i] == "false") {
        Vue.prototype.$env[i] = false;
    }
}

Vue.use(VueCurrencyFilter, {
    symbol: "£",
    fractionCount: 2,
    fractionSeparator: ".",
    symbolSpacing: false,
});
import LessonProConfirm from "./mixins/lesson-pro-confirm.js";
Vue.mixin(LessonProConfirm);
import PremiumPaywall from "./mixins/premium-paywall.js";
Vue.mixin(PremiumPaywall);

Vue.use(Notifications);
//Vue.use(VueDayjs);
import dayjs from "dayjs";
var isBetween = require("dayjs/plugin/isBetween");
var isSameOrAfter = require("dayjs/plugin/isSameOrAfter");

dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);

Object.defineProperties(Vue.prototype, {
    $date: {
        get() {
            return dayjs;
        },
    },
});

import VuePluralize from "vue-pluralize";
Vue.use(VuePluralize);

const VueCurrencyInputOptions = {
    globalOptions: { currency: "GBP" },
};
Vue.use(VueCurrencyInput, VueCurrencyInputOptions);

Vue.config.productionTip = false;

window.axios = require("axios");
window.axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL + "/api";

window.axios.interceptors.request.use((config) => {
    // if(!router.history.current.meta.isAccount){
    //   console.log('not account');
    //  // NProgress.start()
    // }
    return config;
});

window.axios.interceptors.response.use(
    (response) => {
        // perform a task before the request is sent

        return response;
    },
    (error) => {
        // handle the error

        if (error.response && error.response.status == 422) {
            if (router.currentRoute.name !== "proLessonAvailabilityDay") {
                Vue.notify({
                    type: "error",
                    text: "Please check you have filled in all the details correctly",
                });
            }
        } else if (error.response && error.response.status !== 418) {
            Vue.notify({
                type: "error",
                text: "Theres been a problem. Please try again",
            });
        }

        if (!router.currentRoute.meta.isAuthPage) {
            if (error.response && error.response.status == 401) {
                Cookie.remove(process.env.VUE_APP_AUTH_COOKIE_NAME);
                store.state.user = false;
                router.push({ name: "Login" });
            } else {
                return Promise.reject(error);
            }
        }

        return Promise.reject(error);
    },
);

window.navigateTo = function (url) {
    router.push(url);
};

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
